import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {AppState} from '../../app.service';
import { PermissionService } from "./permission.service";
import { Observer } from "rxjs/Observer";
import { Observable } from "rxjs/Observable";

@Injectable()
export class LoginGuard implements CanActivate {

    constructor(
        private router: Router,
        private appState: AppState,
        private permissionService: PermissionService
    ) {
    }

    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        let self: LoginGuard = this;
        return new Observable<boolean>(observer => {
            if (self.permissionService.permissionNames.length) {
                self.loginCheck(observer);
            } else {
                self.permissionService
                    .getPermissions(observer)
                    .subscribe(() => self.loginCheck(observer));
            }
        });
    }

    private loginCheck(observer: Observer<boolean>): void {
        let loggedIn: boolean = this.appState.isLoggedIn();
        if (!loggedIn) {
            this.router.navigate(['/account/login']);
        }
        console.log("LOGGED IN");
        observer.next(loggedIn);
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/services/SecurityServices/login.guard.ts